// extracted by mini-css-extract-plugin
module.exports = {"list":"BulletList_list__wl4Wy"};